import { bootstrap } from '@bootstrap/main'

bootstrap()
